import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import { getMessage } from 'i18n/i18nWrapper';
import { emailVerification } from 'constants/statuses';
import { redirectUser } from 'actions/redirectionActions';
import withSessionRequired from 'hocs/withSessionRequired';

import VerificationFailed from 'components/verification/VerificationFailed';

function mapStateToProps({user, verification}) {
  return {
    isVerified: user.emailVerificationStatus === emailVerification.VERIFIED,
    error: getMessage(verification.error) || getMessage('verificationFailed.genericError'),
    email: user.email
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ redirectUser }, dispatch);
}

export default compose(
  withSessionRequired,
  connect(mapStateToProps, mapDispatchToProps)
)(VerificationFailed);
